var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 20,
    strokeWidth: 1.5,
    d: "M1 12.46c0 .835.678 1.513 1.513 1.513h9.081v0L14.621 17v0V3.013c0-.835-.677-1.513-1.513-1.513H2.513C1.678 1.5 1 2.178 1 3.013z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.208 5.422a.5.5 0 01.729-.446l3.726 1.92a.5.5 0 010 .889L6.937 9.703a.5.5 0 01-.729-.444z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDE2IDE4Ij48Zz48Zz48Zz48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjIwIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTEgMTIuNDZjMCAuODM1LjY3OCAxLjUxMyAxLjUxMyAxLjUxM2g5LjA4MXYwTDE0LjYyMSAxN3YwVjMuMDEzYzAtLjgzNS0uNjc3LTEuNTEzLTEuNTEzLTEuNTEzSDIuNTEzQzEuNjc4IDEuNSAxIDIuMTc4IDEgMy4wMTN6Ii8+PC9nPjxnIHRyYW5zZm9ybT0icm90YXRlKC0zMTUgOCA4KSI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTQuOTEgNy40NDRhLjUuNSAwIDAgMSAuMi0uODNsMy45OTItMS4yNzhhLjUuNSAwIDAgMSAuNjI5LjYyOUw4LjQ1MyA5Ljk1NmEuNS41IDAgMCAxLS44My4yMDF6Ii8+PC9nPjwvZz48L2c+PC9zdmc+";
export { SvgHelpSymbol as ReactComponent };